export default __webpack_public_path__ + "static/TIMBERLINE-M-SERIES-26-C-Nav-WEB-b0ee16e5bc10c03c6b81672ec1c7ee12.png";